import { connect } from "react-redux";
import IocsList from "./IocsList";

import { init, getReferentielsList } from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		iocsList: state.iocs.iocsList,
		page: state.iocs.page,
		pages: state.iocs.pages,
		pageSize: state.iocs.pageSize,
		nbItems: state.iocs.iocsList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "iocs"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(IocsList);


// WEBPACK FOOTER //
// src/containers/admin/iocs/IocsContainer.js